/**
 * Used to draw line in receipts
 * @param n
 */
export const divider = (n = 42, char = '_') =>
  Array.from({ length: n }).fill(char).join('');

export const dashDivider = (n = 42) => divider(n, '-');
